import { useI18n } from 'utils/i18n';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';

export const useLastModifiedDate = (item: useItemHandleFragment$data) => {
  const { format } = useI18n();

  if (!item.lastModifiedAt) {
    return null;
  }
  return format(Number(new Date(item.lastModifiedAt)), 'MMMM do y');
};
